<nb-card>
  <nb-card-header>
    {{ 'test_push_on' | translate }} {{contextTag?'Tag':'App'}}
    {{contextTag?contextTag?.name:contextApp?.name}}
  </nb-card-header>
  <nb-card-body>

    <div *ngIf="contextTag" class="form-group">
      <label>Apps</label><br>
      <nb-select multiple [(selected)]="selectedApps">
        <nb-option *ngFor="let app of filteredApps" [value]="app.id">{{app.name}}</nb-option>
      </nb-select>
    </div>

    <div *ngIf="contextApp" class="form-group">
      <label>Tags</label><br>
      <nb-select multiple [(selected)]="selectedTags" class="tag-select" title={{selectedTags}}>
        <nb-option *ngFor="let tag of filteredTags" [value]="tag.id">{{tag.name}}</nb-option>
      </nb-select>
    </div>

    <div class="form-group">
      <nb-toggle [(ngModel)]="defaultPayload" name="isDefaultPayload" ngDefaultControl>{{ 'default_payload' | translate
        }}</nb-toggle>
    </div>


    <div class="form-group" *ngIf="!defaultPayload">
      <label>Payload (Json-Format)</label><br>
      <json-editor #editorInstance [options]="editorOptions" [(ngModel)]="payload"></json-editor>
    </div>

    <ng-container *ngIf="defaultPayload">
      <div *ngFor="let prop of payloadKeys" class="form-group">
        <label>{{prop | translate}}</label><br>
        <input type="text" nbInput fullWidth fieldSize="small" [(ngModel)]="payload[prop]">
      </div>
    </ng-container>


    <div class="form-group">
      <label>{{ 'device_ids' | translate }} ({{ 'optional_one_per_line' | translate }})</label><br>
      <textarea type="text" nbInput fullWidth fieldSize="small" [(ngModel)]="deviceIds" rows="3"></textarea>
    </div>


  </nb-card-body>
  <nb-card-footer class="d-flex">
    <button nbButton status="primary" class="mr-2" (click)="close()">{{ 'close_dialog' | translate }}</button>
    <button nbButton status="primary" (click)="push()">{{ 'send_test_push' | translate }}</button>
  </nb-card-footer>
</nb-card>
